import React from "react";
import {
  MDBBadge,
  MDBBtn,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
  MDBIcon,
  MDBInput,
} from "mdb-react-ui-kit";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Form from "react-bootstrap/Form";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { PopConfirm } from "Projects/CC_cubi_clan_project/GlobalComponents/PopConfirm/PopConfirm";
import { GroupEditModal } from "../GroupEditModal/GroupEditModal";

import "../sso-management.css";
import "./GestionGrupos.css";

export class GestionGrupos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      allApps: [],
      filterText: "",
      filterApp: "",
      showGroupEditModal: false,
      showGroupDeleteAlert: false,
      selectedGroupEdit: null,
      selectedGroupDelete: null,
    };
  }

  componentDidMount() {
    this.getGrupos();
    this.loadApps();
  }

  loadApps() {
    doFetch("SSO", "getAllAplicaciones", null)
      .then((r) => r.json())
      .then((d) => { if (d.DATA) this.setState({ allApps: d.DATA }); })
      .catch(() => {});
  }

  getGrupos() {
    this.props.onLoading(true);

    doFetch("SSO", "getAllGrupos", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ data: data.DATA });
        // Load app associations for each group
        for (let grupo of data.DATA) {
          if (grupo.IDGrupo) {
            doFetch("SSO", "getGrupo?IDGrupo=" + grupo.IDGrupo, null)
              .then((r) => r.json())
              .then((d) => {
                if (d.DATA && d.DATA.aplicaciones) {
                  grupo._apps = d.DATA.aplicaciones.map(a => a.appNombre);
                  this.setState({ data: [...this.state.data] });
                }
              })
              .catch(() => {});
          }
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  setNewGroup() {
    this.setState({
      showGroupEditModal: true,
      selectedGroupEdit: { IDGrupo: null, nombre: "", descripcion: "" },
    });
  }

  setEditGroup(element) {
    this.setState({ showGroupEditModal: true, selectedGroupEdit: element });
  }

  handleCloseModal() {
    this.setState({ showGroupEditModal: false, selectedGroupEdit: null });
    this.getGrupos();
  }

  confirmGroupDelete(element) {
    this.setState({ showGroupDeleteAlert: true, selectedGroupDelete: element });
  }

  async handlerConfirmDeleteGroup() {
    this.setState({ showGroupDeleteAlert: false });
    let res = await this.deleteGroup();
    if (res) {
      this.getGrupos();
    }
  }

  handlerCancelDeleteGroup() {
    this.setState({ showGroupDeleteAlert: false, selectedGroupDelete: null });
  }

  async deleteGroup() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "DELETE",
    };

    let method =
      "deleteGrupo?IDGrupo=" + this.state.selectedGroupDelete.IDGrupo;

    await doFetch("SSO", method, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  render() {
    return (
      <MDBContainer fluid>
        {this.state.showGroupEditModal ? (
          <GroupEditModal
            showGroupEditModal={this.state.showGroupEditModal}
            data={this.state.selectedGroupEdit}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
          />
        ) : (
          <></>
        )}
        {this.state.showGroupDeleteAlert ? (
          <PopConfirm
            show={this.state.showGroupDeleteAlert}
            title="Confirmar borrar grupo"
            detail="¿Está seguro de que desea borrar el grupo? Se eliminarán todas las asignaciones de permisos y usuarios."
            onConfirm={() => this.handlerConfirmDeleteGroup()}
            onCancel={() => this.handlerCancelDeleteGroup()}
          />
        ) : (
          <></>
        )}
        <MDBContainer fluid className="mt-3 mb-2">
          <MDBRow className="align-items-end g-2">
            <MDBCol md="4">
              <MDBInput
                type="text"
                size="sm"
                label="Buscar grupo..."
                value={this.state.filterText}
                onChange={(e) => this.setState({ filterText: e.target.value })}
              />
            </MDBCol>
            <MDBCol md="3">
              <Form.Select
                size="sm"
                value={this.state.filterApp}
                onChange={(e) => this.setState({ filterApp: e.target.value })}
              >
                <option value="">Todas las apps</option>
                {this.state.allApps.map((a) => (
                  <option key={a.IDAplicacion} value={a.nombre}>{a.titulo || a.nombre}</option>
                ))}
              </Form.Select>
            </MDBCol>
            <MDBCol md="5" className="d-flex justify-content-end">
              <MDBBtnGroup>
                <MDBBtn size="sm" onClick={() => this.setNewGroup()}>
                  <MDBIcon icon="plus" className="me-1" /> Nuevo grupo
                </MDBBtn>
              </MDBBtnGroup>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <MDBTable align="middle" hover responsive className="sso-mgmt-table">
          <MDBTableHead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Descripción</th>
              <th scope="col">Apps</th>
              <th scope="col" style={{ width: "100px" }}>Acciones</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {this.state.data
              .filter((el) => {
                if (this.state.filterText.trim()) {
                  const f = this.state.filterText.toLowerCase();
                  if (!(el.nombre || "").toLowerCase().includes(f) && !(el.descripcion || "").toLowerCase().includes(f)) return false;
                }
                if (this.state.filterApp) {
                  if (!(el._apps || []).includes(this.state.filterApp)) return false;
                }
                return true;
              })
              .map((element, index) => (
              <tr key={index}>
                <td>
                  <div className="d-flex align-items-center">
                    <MDBIcon fas icon="users" className="me-2 text-primary" style={{ fontSize: "0.9rem" }} />
                    <span className="fw-bold" style={{ fontSize: "0.85rem" }}>{element.nombre}</span>
                  </div>
                </td>
                <td style={{ fontSize: "0.83rem" }}>
                  {element.descripcion || <span className="text-muted">Sin descripción</span>}
                </td>
                <td className="sso-badge-cell">
                  <div className="sso-badge-overflow">
                    {(element._apps || []).map((name, ai) => (
                      <MDBBadge key={ai} color="primary" pill className="me-1 mb-1">{name}</MDBBadge>
                    ))}
                  </div>
                </td>
                <td className="sso-actions-cell">
                  <OverlayTrigger placement="top" overlay={<Tooltip>Editar</Tooltip>}>
                    <span className="d-inline-block">
                      <MDBBtn color="primary" outline className="mx-1" floating size="sm" onClick={() => this.setEditGroup(element)}>
                        <MDBIcon icon="edit" />
                      </MDBBtn>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>Eliminar</Tooltip>}>
                    <span className="d-inline-block">
                      <MDBBtn color="danger" outline className="mx-1" floating size="sm" onClick={() => this.confirmGroupDelete(element)}>
                        <MDBIcon icon="times" />
                      </MDBBtn>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
            ))}
          </MDBTableBody>
        </MDBTable>
      </MDBContainer>
    );
  }
}
